/* global s */
'use strict';

class ScrollSpy {
	constructor(options) {
		this.defaults = {
			selectors: {
				select_id: 'scrollspy-category-select',
				kc_nav_id: 'nav-wrapper',
				side_menu_id: 'scrollspy-menu'
			}
		};
		this.options = Object.assign(this.defaults, options);
		this.pageEvents();
	}
	pageEvents() {
		let menu_offset = 70;
		let _kc_nav = document.getElementById(this.options.selectors.kc_nav_id);
		if (_kc_nav) {
			menu_offset = _kc_nav.offsetHeight;
		}

		//scroll to the required element on select on mobile
		let _elem = document.getElementById(this.options.selectors.select_id);
		if (_elem) {
			_elem.addEventListener('change', () => {
				if (_elem.options[_elem.selectedIndex].value) {
					let _href = _elem.options[_elem.selectedIndex].value;
					window.location.hash = _href;
					let _selected_element = document.getElementById(_href);
					if (_selected_element) {
						_selected_element.scrollIntoView();
					}
					window.scrollBy(0, -(menu_offset+50));
				}
			});
			let _existing_hash = location.hash.substring(1);
			for (let _i = 0;_i < _elem.options.length;_i++) {
				if (_elem.options[_i].value === _existing_hash) {
					_elem.selectedIndex = _i;
					break;
				}
			}
		}

		//scroll to the required element on select on desktop
		let _scrollspy_menu = document.getElementById(this.options.selectors.side_menu_id);
		if (_scrollspy_menu) {
			_scrollspy_menu.querySelectorAll('a').forEach((el) => {
				el.addEventListener('click', function (e) {
					let _href = this.getAttribute('href');
					e.preventDefault();
					window.location.hash = _href;
					let _selected_element = document.getElementById(_href);
					if (_selected_element) {
						_selected_element.scrollIntoView();
					}
					window.scrollBy(0, -(menu_offset+50));
				});
			});
		}
	}
}
